import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import {
  getImpersonationBounceToastMessage,
  stripImpersonationBounceReason,
} from "src/utils/impersonationRevocationUrl";

/**
 * Shows a revoke toast after a hard bounce (window.location.assign) and strips
 * the reason query param so refresh/back does not repeat it.
 */
function ImpersonationRevocationToast(): null {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const message = getImpersonationBounceToastMessage(location.search);
    if (!message) return;

    toast.error(message);
    history.replace({
      pathname: location.pathname,
      search: stripImpersonationBounceReason(location.search),
      hash: location.hash,
    });
  }, [history, location.hash, location.pathname, location.search]);

  return null;
}

export default ImpersonationRevocationToast;
